import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';
import TicketStack from 'components/dashboard/EntriesAndStats/TicketStack';
import { GameType } from '@daymade/common-lib/dbEnums';
import { IEntryLine } from 'types/Draws';

const entries: IEntryLine[] = [
  {
    type: GameType.LOTTERY,
    main: [1, 2, 3, 4],
    bonus: [5],
  },
  {
    type: GameType.LOTTERY,
    main: [22, 33, 44, 55],
    bonus: [8],
  },
];

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'} withNoPadding>
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">TicketStack</h3>
        <p>
          A ticket stack. It fills its container. It scales the size of the font
          with the available width of the component
        </p>
        <p> It can start initially expanded</p>
        <div style={{ width: 240 }}>
          <TicketStack entries={entries} onlyExpanded />
        </div>
        <p> The component can also require the user to open it</p>

        <div style={{ width: 240 }}>
          <TicketStack entries={entries} />
        </div>
        <div style={{ width: 300 }}>
          <TicketStack entries={entries} />
        </div>
        <div style={{ width: 360 }}>
          <TicketStack entries={entries} />
        </div>
        <div style={{ width: 500 }}>
          <TicketStack entries={entries} />
        </div>
        <div style={{ width: 800 }}>
          <TicketStack entries={entries} />
        </div>
        <div>
          <TicketStack entries={entries} />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Ticket Stack',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
